/**
 * Scenery zone types and setup for deterministic visual scenery sync.
 * All clients receive the same ScenerySetup from the server, ensuring
 * identical visual scenery regardless of join time.
 */
// Zone type constants — extensible for future scenery types
export const SCENERY_ZONE_GAS_CLOUD = 0;
export const SCENERY_ZONE_DEBRIS_FIELD = 1;
export const SCENERY_ZONE_NEBULA_PATCH = 2;
//# sourceMappingURL=scenery.js.map